import { Alert } from "react-bootstrap";
import DefaultSlide from "../../components/Slides/templates/DefaultSlide";
import ImageSlide from "../../components/Slides/templates/ImageSlide";
import TitleSlide from "../../components/Slides/templates/TitleSlide";
import StudentPicker from "../../components/global/StudentPicker";
import { ISlideObject } from "../../components/Slides/templates/ISlideObject";
import CodeSlide from "../../components/Slides/templates/CodeSlide";
import { useEffect, useRef } from "react";
import "./S04P01.css";
import CodePen from "../../components/Codepen/Codepen";

interface ToastifyOptions {
  text: string;
  duration?: number;
  newWindow?: boolean;
  close?: boolean;
  gravity?: "top" | "bottom";
  position?: "left" | "center" | "right";
  stopOnFocus?: boolean;
  style?: Record<string, string>;
  onClick?: () => void;
}

declare function Toastify(options: ToastifyOptions): { showToast: () => void };

export default function S09P01({ reveal }: ISlideObject) {
  return (
    <>
      <TitleSlide
        title="TI8512 - Desarrollo Ágil de Aplicaciones Web"
        subtitle="Semana 09"
      />
      <DefaultSlide title="Agenda">
        <div style={{ fontSize: "0.75em" }}>
          <ul>
            <li>
              Introducción a React
              <ul>
                <li>
                  Qué es y que <strong>no</strong> es?
                </li>
                <li>Quién utiliza React?</li>
                <li>Por qué utilizan React?</li>
                <li>Ejemplo básico de React</li>
              </ul>
            </li>
            <li>To-do app con Vanilla JS</li>
            <li>Conceptos de React</li>
            <li>To-do app con React</li>
          </ul>
        </div>
      </DefaultSlide>
      <section>
        <DefaultSlide title="Introducción a React">
          <div>
            <ul>
              <li>
                React es una biblioteca de JavaScript para construir interfaces
                de usuario.
              </li>
              <li>
                React se basa en componentes, que son piezas reutilizables de
                código que representan una parte de la interfaz de usuario.
              </li>
              <li>
                React utiliza un DOM virtual para mejorar el rendimiento y la
                eficiencia al actualizar la interfaz de usuario.
              </li>
            </ul>
          </div>
        </DefaultSlide>

        <DefaultSlide title="Qué es y que no es?">
          <div>
            <ul>
              <li>React es una biblioteca de JavaScript.</li>
              <li>React no es un framework.</li>
              <li>React no es un lenguaje de programación.</li>
            </ul>
          </div>
        </DefaultSlide>

        <DefaultSlide title="Quién utiliza React?">
          <div>
            <ul>
              <li>Facebook</li>
              <li>Instagram</li>
              <li>Netflix</li>
              <li>WhatsApp</li>
            </ul>
          </div>
        </DefaultSlide>

        <DefaultSlide title="Por qué utilizan React?">
          <div>
            <ul>
              <li>Simplicidad</li>
              <li>Rendimiento</li>
              <li>Escalabilidad</li>
              <li>Mantenibilidad</li>
            </ul>
          </div>
        </DefaultSlide>
      </section>

      <section>
        <h2>Ejemplo de implementación con JavaScript puro</h2>
      </section>

      <section>
        <TitleSlide title="Conceptos de React" />
        <DefaultSlide title="Componentes">
          <div>
            <ul>
              <li>Los componentes son la base de React.</li>
              <li>
                Los componentes pueden ser de clase o funcionales.
                <ul>
                  <li>
                    Componentes de clase: utilizan la sintaxis de clase de
                    JavaScript.
                  </li>
                  <li>
                    Componentes funcionales: son funciones que devuelven JSX.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </DefaultSlide>

        <DefaultSlide title="Cómo crear una aplicación React">
          <div>
            <ul>
              <li>
                Instalar Node.js y npm (Node Package Manager) en tu sistema.
              </li>
              <li>
                Usar el comando{" "}
                <code>npx create-react-router@latest</code> para crear
                una nueva aplicación React.
              </li>
              <li>
                Navegar al directorio de la aplicación con{" "}
                <code>cd nombre-de-tu-app</code>.
              </li>
              <li>
                Iniciar el servidor de desarrollo con <code>npm start</code>.
              </li>
              <li>
                Abrir el navegador en <code>http://localhost:3000</code> para
                ver la aplicación en funcionamiento.
              </li>
            </ul>
          </div>
        </DefaultSlide>
      </section>

      <ImageSlide image="/images/S06/dancing6.gif" title="Fin de parte 1" />
    </>
  );
}
